import { api } from './api';

// Read-only lookup of the 16 German federal states. Backed by static seed
// data on the server so the result is heavily cacheable; we keep the default
// RTK Query cache lifetime.
export const federalStatesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFederalStates: build.query({
      query: () => ({
        url: 'federal-states',
        method: 'GET',
      }),
      transformResponse: (response) => response.data,
    }),
  }),
});

export const {
  useGetFederalStatesQuery,
  useLazyGetFederalStatesQuery,
} = federalStatesApi;
